import React from "react";
import {commafyPlural, get_dur, isObject, isSearchInStrings, minUnitsBiz, objRmKeysC, objToArrK, pickKeys} from "../tools/CommonJS";
import {dateToPassed} from "../tools/CommonHtml";
import {objToArrKH} from "../tools/CommonReact";
import {Button} from "../tools/Inputs";
import {FilterPills} from "./CommonUIComponenets";

export const modulesDefs = {
    miscon: {h: "Misconfiguration", desc: "Devices with threats", objName: "device"},
    benchmark: {h: "Benchmark", desc: "Deviations", objName: "control"},
    ad: {h: "Active Directory", desc: "Threats and insights", objName: "setting"},
    gp: {h: "Policy Validation", desc: "Misconfigurations", objName: "GPO"},
    profiler: {h: "Profiler", desc: ""},
};

export const currencySymbols = {
    USD: {s: "$", h: "$ US Dollars"},
    GBP: {s: "£", h: "£ British Pounds"},
    EU: {s: "€", h: "€ Euros"},
}, currencySymbolsOpts = objToArrK(currencySymbols);

export const selTargetDefs = {
    "!server":              {h: "Win endpoints (inc. VDIs)", shortH: "Windows", desc: "Win endpoints", objName: "endpoint", color: "#537dee"},
    "global":               {h: "Trending Global Attack Vectors", desc: "Global concerning threats", objName: "#696F7F"},
    "vdi":                  {h: "VDIs", shortH: "VDIs", desc: "VDI endpoints", hCap: "VDIs", objName: "VDI", color: "#0e4380"},
    "kubernetes":           {h: "Kubernetes", shortH: "K8s", desc: "Kubernetes containers", objName: "VDI", color: "#93AAE7"},
    "mac":                  {h: "macOS", shortH: "macOS", desc: "Macs", objName: "devices", color: "#77C1E8"},
    "!vdi !server":         {h: "Win endpoints", shortH: "Windows", desc: "Non-VDI endpoints", objName: "endpoint", color: "#0090d9"},
    "server":               {h: "Win servers (inc. DCs)", shortH: "Windows", desc: "Win servers", objName: "server", color: "#0079be"},
    "dc":                   {h: "DCs", shortH: "Windows", desc: "Win DC servers", hCap: "DCs", objName: "Win Domain Controller", color: "#757ccc"},
    "server !dc":           {h: "Servers (non-DCs)", shortH: "Windows", desc: "Win Non-DC servers", objName: "server", color: "#FEAF88"},
    "debian":               {h: "Debian", shortH: "Linux", desc: "Linux Debian", objName: "devices", color: "#0079be"},
    "rhel":                 {h: "Red Hat", shortH: "Linux", desc: "Linux Red Hat", objName: "devices", color: "#0079be"},
    "suse":                 {h: "SUSE", shortH: "Linux", desc: "Linux SUSE", objName: "devices", color: "#93b4fd"},
    "networks":             {h: "Network Devices", shortH: "Network", desc: "Routers, switches and firewalls", objName: "network", color: "#049fd8"},
    "linux-unknown":        {h: "Others", shortH: "Linux", desc: "Other linuxes", objName: "devices", color: "#76859d"},
    //"fedora": {}, "gentoo": {}, "slackware": {}, "arch": {}, "exherbo": {}, "alpine": {}, "coreos": {}, "solus": {},
}, selTargetOpts = objToArrK(selTargetDefs);


export const severitiesDefs = {
    High: {idx: 0, c: "threat", h: 'Critical', bg: "bg-threat", tx: "text-threat", border: "border-threat", color: "#ff5656"},
    Medium: {idx: 1, c: "medium", h: 'Medium', bg: "bg-medium", tx: "text-medium", border: "border-medium", color: "#ff943d"},
    Low: {idx: 2, c: "warning", h: 'Low', bg: "bg-warning", tx: "text-warning", border: "border-warning", color: "#fff162"},
    Passed: {idx: 3, c: "success", h: 'Good', bg: "bg-success", tx: "text-success", border: "border-success", color: "#4ed37c"},
    Unknown: {idx: 4, c: "handle", h: 'Unknown', bg: "bg-handle", tx: "text-handle", border: "border-handle"},

    unknown: {idx: 5, c: "threat", h: 'Non-Compliant', bg: "bg-threat", tx: "text-threat", border: "border-threat", color: "#ff5656"},
    passed: {idx: 6, c: "success", h: 'Compliant', bg: "bg-success", tx: "text-success", border: "border-success", color: "#4ed37c"},
    
    Complied: {idx: 3, c: "success", h: 'Good', bg: "bg-success", tx: "text-success", border: "border-success", color: "#4ed37c"},
}, severitiesDefsArr = objToArrK(severitiesDefs);

export const formatSevForParam = severities => !severities?.length? null : severities?.map(si => severitiesDefsArr[si].k);

export const convertToDaysAgo = (timestamp) => dateToPassed(timestamp, {noDate: true}) +" ago";

export const getBizDur = (m) => get_dur(m *1000, {
    altUnits: minUnitsBiz, sep: " ", topOnly: 1, addUnit: 2});

export const dispBizDur = (m, tipFormat) =>
    <span title={m <= 60*8? undefined : (tipFormat ?? "$1").format((m/60 + 0.5|0).toLocaleString() +" business hours")}>
        {getBizDur(m)}
    </span>;


export const c_accessFull = "full", c_accessView = "read";
export const permAdmin = {groupId: 0, access: c_accessFull}

export const isGroupAll = groupId => !groupId;
export const checkRoleAdmin = perm => isGroupAll(perm?.groupId) && perm?.access === c_accessFull;
export const checkRoleViewOnly = perms => !perms?.some(perm => perm.access === c_accessFull);       // really noAnyFullAccess ;)

export const groupNameAll = "All my devices";

export const dispGroupName = obj => {
    let {groupId, groupName} = (obj?.rowData ?? obj) || {};
    return isGroupAll(groupId)? groupNameAll : groupName || `(group id: ${groupId})`;
};

export function dispGroupNameById({groupId, groups}) {
    return !groups? null : dispGroupName(groups?.find(g => g.groupId === groupId));
}

export const arrToInpOpts = (arr) => arr.map(h => ({h, k: h}));

export const prepGroupTotalsForSum = (tgts) => {
    const donutProps = tgts.map(tgt => ({
        name: selTargetDefs[tgt.selTarget]?.h?.replace(/(Windows)/g, "Win"),
        value: tgt.devices,
    }));

    return donutProps.sort((a,b) => b.value - a.value);
}

export function jsonParse(json, silent) {
    try {
        return JSON.parse(json);
    } catch (err) {!silent && console.error(err)}
}

// export const arrToStr = (arr) =>  arr.reduce(acc, )

export function showAddInfo(cellData, flags) {
    const {oneLine, nameVal, knownKeys, sJoin} = flags || {};
    let addInfo = !cellData? {} : typeof cellData === "string" && jsonParse(cellData, true) || cellData;
    if (addInfo === "null") return null;
    if (typeof addInfo !== "object")
        return addInfo;
    if (addInfo.length === 1 && typeof addInfo[0] === "object") {
        if (!addInfo[0])
            return addInfo[0];
        addInfo = addInfo[0];
    } else if (["string", "number"].includes(typeof addInfo[0]))
        return addInfo.join(sJoin || (oneLine? ", " : '\n'));
    if (nameVal && typeof addInfo[0] === "object")
        addInfo = addInfo.reduce((acc, elm) => {
            const val = elm.value;
            acc[elm.name] = typeof val === "string" ? val : val && val.join('\n') || val;
            return acc;
        }, {});
    if (isObject(addInfo))
        return !oneLine ? objToArrKH(addInfo)
            : Object.entries(addInfo).map(entry => entry.join(": ")).join(", ");
}

export const showAddInfoLine_nameVal = obj => showAddInfo(obj, {oneLine: 1, nameVal: 1});

export function adjustAddInfoKeys(addInfo) {
    // remove key "And" which is a DSL based alert.
    return Array.isArray(addInfo) ? addInfo?.filter(v => v?.h !== "And") : addInfo;
}

export const alertOnlyOpt = [{h: 'All Measures', k: false}, {h: 'Live Alerts Only', k: true}]
export const miscOpt = ['All alerts', 'Quick wins', 'Pinned'].map((h) => ({h, k: h}))

export const doesSearchIncTpc = (repo, search) => isSearchInStrings(search, repo?.title, repo?.subj);

export const calcDollarsSaved = (alerts, FTE, itMin = 3) => alerts * itMin / minUnitsBiz.year * FTE;

export const calculateSaving = (repoRemedies, cur) => {
    const remItMin = Object.values(repoRemedies)[0]?.itMinutes || 2;
    const achieved = remItMin * cur.alertsRemediated;
    const potential = remItMin * cur.alertsRemediable;
  
    return { achieved, potential };
  }

export const statusPillDefs = {
    Recurring: {border: "border-warning/90", tip: val => commafyPlural(val, "alert") + " recurred since the alert has been remediated!"},
    Pending: {border: "border-pending", tip: val => "View " + commafyPlural(val, "pending remediation task", ) +" in the Action Center."},
    Muted: {border: "border-[#c9b31699]", tip: val => commafyPlural(val, "alert", ["is", "are"]) +" muted."},
    Remediated: {border: "border-prm-main", tip: val => commafyPlural(val, "alert", ["was", "were"]) +" remediated."},
    "New": {tip: val => commafyPlural(val, "new alert", ["has", "have"]) +" appeared."}
};

export const periodDefs = {
    "1d": {h: "< 24h", c: "#b2d1ff", tip: "Devices scanned within the last 24 hours."},
    "3d": {h: "< 3d", c: "#86a8fc", tip: "Devices scanned within the last 3 days."},
    "1w": {h: "< 1w", c: "#0090d9", tip: "Devices scanned within the last week."},
    "2w": {h: "< 2w", c: "#0e4380", tip: "Devices scanned within the last 2 weeks."}
}, periodDefsArr = objToArrK(periodDefs);

export const registrationDatePeriodDefs = {
    "lt_1d": {h: "< 24h", c: "#b2d1ff", tip: "Devices registered within the last 24 hours."},
    "lt_7d": {h: "< 7d", c: "#86a8fc", tip: "Devices registered within the last 7 days."},
    "lt_1m": {h: "< 1m", c: "#0090d9", tip: "Devices registered within the last month."},
    "gt_1m": {h: "> 1m", c: "#0e4380", tip: "Devices registered more than a month ago."},
}, registrationDatePeriodDefsArr = objToArrK(registrationDatePeriodDefs);

export const combiDefsStd = {
    device: {
        k: "device", h: "Device Name",
        getValsOnChange: ({idx, rsp}) => ({deviceGuid: rsp?.deviceGuid?.[idx]}),
        gen: ({val: device, exact: deviceGuid}) => deviceGuid? {deviceGuid} : {device},
        qExact: "deviceGuid"
    },
    param: repo => ({
        k: "param", h: repo?.paramTitle? `${repo.paramTitle} (Instance)` : "Attack Vector Instance",
        getValsOnChange: ({idx, rsp}) => ({paramExtra: rsp?.paramExtra?.[idx]}),
        gen: ({val: param, exact: paramExtra}) => ({param, paramExtra, isExactParam: paramExtra !== undefined || undefined}),
        qExact: "paramExtra"
    }),
    groupId: {k: "groupId", h: "Group"},
    os: {k: "os", h: "Operating System", qExact: "isExactOs"},
    computerOu: {k: "computerOu", h: "Org. Unit", qExact: "isExactComputerOu"},
    ip: {k: "ip", h: "IP Address"},
    domain: {k: "domain", h: "Domain"},
    user: {k: "user", h: "User"},
    label: {
        k: "label", h: "Label",
        hEx: <div className="flex items-center gap-2">
            Label
            <Button className="icon-graduation-cap text-xs text-subtitle1"
                    onClick={e => window.open("https://gytpol.atlassian.net/wiki/spaces/KB/pages/411205633/Device+Labeling+-+How+To", "_blank")}
                    title="See Sensor installation Knowledge-Base to learn about Sensor Labeling options..."/>
        </div>,
        comboProps: {selectMode: true},
    },
    clientVer: {k: "clientVer", h: "Sensor Version", comboProps: {selectMode: true}},
    osVersion: {
        k: "osVersions", qField: "osVersion", h: "OS Version", tip: "Filter by OS Display Version (Windows) or OS Build (macOS, Linux).",
        multi: true, combProps: {maxVals: 10, classNameItemText: "max-w-28 text-xs"}
    },
    benchmarkLevel: {k: "benchmarkProfile", h: "Compliance Profile", comp: ({field, val, onChange}) =>
            <FilterPills opts={benchmarkLevelOpts} className="text-sm" value={val} {...{field, onChange}}/>},
    benchmarkName: {k: "benchmarkName", h: "Benchmark Name", comboProps: {selectMode: true}},
    // severities: (severityVals = makeArr(4).map(i => ({k: i}))) => ({
    //     k: "severities", h: "Severities", comp: ({field, val: selKeys, onChange}) =>
    //         <SeverityPicker {...{field, onChange, selKeys, severityVals}}/>,
    //     gen: ({val}) => ({severities: formatSevForParam(val)}),
    // }),

    user_arr: {k: "user", h: "User", gen: ({val: user, exact}) => !exact? {user} : {user: [user]}},
    gpoName_arr: {k: "gpoName", h: "GPO", gen: ({val: gpoName, exact}) => !exact? {gpoName} : {gpoName: [gpoName]}},
    gpSettingName_arr: {k: "gpSettingName", h: "Setting", gen: ({val: gpSettingName, exact}) => !exact? {gpSettingName} : {gpSettingName: [gpSettingName]}},
    gpoDomain_arr: {k: "gpoDomain", h: "Domain", gen: ({val: gpoDomain, exact}) => !exact? {gpoDomain} : {gpoDomain: [gpoDomain]}},
    ou: {k: "ou", h: "Org. Unit"},
    device_arr: {
        k: "device", h: "Device Name", qExact: "deviceGuids",
        getValsOnChange: ({idx, rsp}) => ({deviceGuids: [rsp?.deviceGuid?.[idx]]}),
        gen: ({val: device, exact: deviceGuids}) => deviceGuids? {deviceGuids} : {device},
    },
};

export const benchmarkLevelOpts = [
    {k: undefined, h: "All"},
    {k: "*Level_1*", h: "Level 1"},
    {k: "*Level_2*", h: "Level 2"},
    {k: "*STIG*", h: "STIG"},
];


export const formatDeviceInfo = (deviceInfo, clientVers = undefined) => {
    const clientVerChannel = clientVers?.find(cv => cv.clientVer === deviceInfo?.clientVersion && cv.clientType === deviceInfo?.clientType)?.channel;
    
    const defs = [
        {
            h: "Host Name",
            k: ["hostname", "isVDI", "isDecommissioned"],
            d: (val, deviceInfo) => val && <div className="flex items-center gap-3">{val}{deviceInfo?.isVDI &&
                <span className="icon-vdi leading-5 text-lg text-title"/>}</div>
        },
        {h: "IP Address", k: ["ip", "IP"]},
        {h: "Operating System", k: ["os", "OS"]},
        {h: "Group Membership", k: "groupMembership", d: (val) => val?.map(v => v.groupName)},
        {
            h: "Sensor Version", k: ["clientVersion", "clientType"],
             d: (val) => val && <div className="flex gap-2">
                {val}
                <p className={clientVerChannel === "latest" ? "text-prm-dark" : "text-pending"}>
                    {clientVerChannel ? `(${clientVerChannel})` : "(update available)"}
                </p>
            </div>
        },
        {h: "Last Report", k: "lastReport", d: (val) => dateToPassed(val)},
        {h: "Last Remediation", k: "lastRemediation", d: (val) => dateToPassed(val)},
        ...(!deviceInfo?.labels?.length ? [] : [{h: "Labels", k: "labels", d: (val) => val.join(", ")}]),
        {h: "Domain Name", d: (_, deviceInfo) => deviceInfo?.metadata?.DomainName && (deviceInfo.metadata.DomainName
                + (!deviceInfo?.hostname ? "" : ` (${deviceInfo.hostname}.${deviceInfo.metadata.DomainName})`))},
        {
            h: "Metadata", k: "metadata", d: (val) => val && objToArrKH(pickKeys(deviceInfo.metadata,
                "HW_CPU", "HW_Model", "HW_RAM", "HW_Serial", "OsBuild", "OsDisplayVersion", "MachineType", "NodeVendor", "MacAddress"))
        },
    ]

    let dispItems = defs.map(info =>
        ({...info, k: info.d ?
                info.d(deviceInfo?.[Array.isArray(info.k) ? info.k[0] : info.k], deviceInfo)
                : Array.isArray(info.k) ? info.k.map(key => deviceInfo?.[key]).filter(Boolean)[0]
                    : deviceInfo?.[info?.k] }))
    dispItems.splice(defs.length - 1, 0,
        ...(!deviceInfo ? [] : objToArrKH(objRmKeysC(deviceInfo, defs.map(def => def.k).flat()))))  // add deviceInfo fields that weren't augmented

    return dispItems;
};
